import "./Footer.css"

const Footer = () => {
    return (
        <footer class="footer">
        <div class="footer-container">
      

          <div class="footer-box">
            <h2 class="footer-logo">Bella Vega</h2>
            <p>Elegant handbags crafted for modern women. Carry your grace, own your style.</p>
      
            <div class="social-icons">
              <a href="#">🌐</a>
              <a href="#">📸</a>
              <a href="#">🐦</a>
              <a href="#">▶</a>
            </div>
          </div>
      

          <div class="footer-box">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="#">Home</a></li>
              <li><a href="#">Shop</a></li>
              <li><a href="#">About Us</a></li>
              <li><a href="#">Contact</a></li>
            </ul>
          </div>
      
  
          <div class="footer-box">
            <h3>Categories</h3>
            <ul>
              <li><a href="#">Tote Bags</a></li>
              <li><a href="#">Sling Bags</a></li>
              <li><a href="#">Party Bags</a></li>
              <li><a href="#">Combo Sets</a></li>
            </ul>
          </div>
      
  
          <div class="footer-box">
            <h3>Newsletter</h3>
            <p>Subscribe for offers & latest trends.</p>
      
            <form class="newsletter-form">
              <input type="email" placeholder="Enter your email" required />
              <button type="submit">Subscribe</button>
            </form>
          </div>
      
        </div>
      
     
        <div class="footer-bottom">
          <p>© 2026 Bella Vega. All Rights Reserved.</p>
        </div>
      </footer>
      
    );
}

export default Footer;